import React, { useState, useMemo } from 'react';

const AddTransactionModal = ({ isOpen, onClose, onAddTransaction, accounts, scope, categories, vendors }) => {
    const [description, setDescription] = useState('');
    const [amount, setAmount] = useState('');
    const [type, setType] = useState('expense');
    const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
    const [category, setCategory] = useState(categories[0] || '');
    const [vendor, setVendor] = useState('');
    const [frequency, setFrequency] = useState('Once');
    const [accountId, setAccountId] = useState(accounts[0]?.id || '');
    const [categorySearch, setCategorySearch] = useState('');

    const filteredCategories = useMemo(() => {
        if (!categorySearch) {
            return categories;
        }
        return categories.filter(cat =>
            cat.toLowerCase().startsWith(categorySearch.toLowerCase())
        );
    }, [categories, categorySearch]);
    
    if (!isOpen) return null;

    const handleSubmit = (e) => {
        e.preventDefault();
        const finalAmount = type === 'expense' ? -Math.abs(Number(amount)) : Math.abs(Number(amount));
        onAddTransaction({ description, amount: finalAmount, date, category, accountId, scope, vendor, frequency });
        onClose();
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg p-6 w-full max-w-md shadow-xl">
                <h3 className="text-lg font-semibold text-gray-800 mb-4">Add New Transaction</h3>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium">Account</label>
                        <select value={accountId} onChange={(e) => setAccountId(e.target.value)} className="mt-1 w-full px-3 py-2 border rounded-md" required>
                            {accounts.map(acc => <option key={acc.id} value={acc.id}>{acc.name}</option>)}
                        </select>
                    </div>
                    <div>
                        <label className="block text-sm font-medium">Description</label>
                        <input type="text" value={description} onChange={(e) => setDescription(e.target.value)} className="mt-1 w-full px-3 py-2 border rounded-md" required />
                    </div>
                    <div>
                        <label className="block text-sm font-medium">Vendor</label>
                        <input list="vendors" value={vendor} onChange={(e) => setVendor(e.target.value)} className="mt-1 w-full px-3 py-2 border rounded-md" placeholder="e.g., Woolworths, Netflix" />
                        <datalist id="vendors">
                            {vendors.map(v => <option key={v} value={v} />)}
                        </datalist>
                    </div>
                    <div>
                        <label className="block text-sm font-medium">Amount</label>
                        <input type="number" step="0.01" value={amount} onChange={(e) => setAmount(e.target.value)} className="mt-1 w-full px-3 py-2 border rounded-md" required />
                    </div>
                    <div>
                        <label className="block text-sm font-medium">Type</label>
                        <select value={type} onChange={(e) => setType(e.target.value)} className="mt-1 w-full px-3 py-2 border rounded-md">
                            <option value="expense">Expense</option>
                            <option value="income">Income</option>
                        </select>
                    </div>
                    <div>
                        <label className="block text-sm font-medium">Date</label>
                        <input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="mt-1 w-full px-3 py-2 border rounded-md" required />
                    </div>
                    <div>
                        <label className="block text-sm font-medium">Category</label>
                        <input 
                            type="text" 
                            value={categorySearch} 
                            onChange={(e) => setCategorySearch(e.target.value)} 
                            className="mt-1 w-full px-3 py-2 border rounded-md" 
                            placeholder="Search categories..."
                        />
                        <select value={category} onChange={(e) => setCategory(e.target.value)} className="mt-1 w-full px-3 py-2 border rounded-md" size={filteredCategories.length > 1 ? Math.min(filteredCategories.length, 5) : 2}>
                            {filteredCategories.map(catName => <option key={catName} value={catName}>{catName}</option>)}
                        </select>
                    </div>
                    <div>
                        <label className="block text-sm font-medium">Frequency</label>
                        <select value={frequency} onChange={(e) => setFrequency(e.target.value)} className="mt-1 w-full px-3 py-2 border rounded-md">
                            <option>Once</option>
                            <option>Weekly</option>
                            <option>Fortnightly</option>
                            <option>Monthly</option>
                            <option>Quarterly</option>
                            <option>Yearly</option>
                        </select>
                    </div>
                    <div className="flex justify-end space-x-3 pt-2">
                        <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-200 rounded-md">Cancel</button>
                        <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded-md">Add Transaction</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddTransactionModal;